import { createAdminRequest, createRequest } from '../helpers/api_utils';
import { Organization, OrganizationCreate } from '../types/admin_types';
import { apiUrl } from './api_url';

const apiEndpoint = apiUrl + '/organization';
const apiAdminEndpoint = apiUrl + '/admin/organization';

export async function getOrganization() {
  return fetch(createRequest(apiEndpoint, 'GET', 'application/json', true));
}

export async function getOrganizationById(organization_id: string) {
  return fetch(createRequest(apiEndpoint + `/${organization_id}`, 'GET', 'application/json', true));
}

export async function updateOrganization(organization: Organization) {
  return fetch(createRequest(apiEndpoint, 'PUT', 'application/json', true, organization));
}

export async function createOrganization(organization: OrganizationCreate) {
  return fetch(createAdminRequest(apiAdminEndpoint, 'POST', 'application/json', true, organization));
}

export async function getOrganizationLogo() {
  return fetch(createRequest(apiEndpoint + '/init', 'GET', 'application/json', true));
}

/* ------------------------------------------------------------------ *
 * Candidate status email templates
 *
 * Per-organization wording for the Unsuccessful / Waitlisted /
 * Shortlisted emails. Where a tenant has not customised one, the API
 * returns the platform default so the editor always has a starting point.
 * ------------------------------------------------------------------ */

export interface ICandidateStatusTemplate {
  templateKey: 'unsuccessful' | 'waitlisted' | 'shortlisted';
  templateHtml: string;
  templateJson: string | null;
  isCustomised: boolean;
  updatedAt: string | null;
}

export interface ICandidateStatusTemplates {
  templates: ICandidateStatusTemplate[];
  variables: { name: string; variable: string }[];
}

const emailTemplatesEndpoint = apiEndpoint + '/email-templates';

export async function getCandidateStatusTemplates() {
  return fetch(createRequest(emailTemplatesEndpoint, 'GET', 'application/json', true));
}

export async function updateCandidateStatusTemplate(
  templateKey: string,
  body: { templateHtml: string; templateJson?: string },
) {
  return fetch(
    createRequest(`${emailTemplatesEndpoint}/${templateKey}`, 'PUT',
      'application/json', true, body),
  );
}

/** Remove the override so the status reverts to the platform default wording. */
export async function resetCandidateStatusTemplate(templateKey: string) {
  return fetch(
    createRequest(`${emailTemplatesEndpoint}/${templateKey}`, 'DELETE',
      'application/json', true),
  );
}
